<script lang="ts">
  import { createEventDispatcher, onMount } from 'svelte';

  import IconDown from '@/comps-sdk/components/icon/arrow-down.svelte';
  import IconLeft from '@/comps-sdk/components/icon/arrow-left.svelte';
  import Popup from '@/comps-sdk/components/popup/src/popup.svelte';

  export let value = false;
  export let title = '';
  export let closeOnClickOverlay = false;

  /**
   * 渲染到哪个节点上
   */
  export let getContainer: string = '';

  let el: HTMLElement | null = null;

  const dispatch = createEventDispatcher();

  let minHeight = '26px';
  $: {
    minHeight = title ? '64px' : '26px';
  }

  const onClickOverlay = () => {
    if (closeOnClickOverlay) {
      dispatch('input', false);
      dispatch('close');
    }
  };

  const onClickBack = () => {
    dispatch('back');
    dispatch('close');
  };

  const onClickClose = () => {
    dispatch('input', false);
    dispatch('close');
  };

  onMount(() => {
    if (getContainer) {
      const container = document.querySelector(getContainer);
      container?.append(el!);
    }
  });
</script>

<div bind:this={el}>
  <Popup
    {value}
    position={'bottom'}
    round={true}
    closeOnClickOverlay={false}
    class="act-sdk-drawer-wrapper"
    on:clickOverlay={onClickOverlay}
  >
    <div class="header-wrapper" style:min-height={minHeight}>
      {#if title}
        <div class="title-wrapper">
          <div role="button" tabindex="0" class="back-icon" on:click={onClickBack} on:keydown={() => {}}>
            <IconLeft />
          </div>
          <div class="title">
            {title}
          </div>
        </div>
      {:else}
        <div role="button" tabindex="0" class="close-btn" on:click={onClickClose} on:keydown={() => {}}>
          <IconDown />
        </div>
      {/if}
    </div>
    <div class="drawer-content">
      <slot />
    </div>
  </Popup>
</div>

<style lang="scss">
  :global(.act-sdk-drawer-wrapper) {
    max-height: 80vh;
    background: #fff;
    display: flex;
    flex-direction: column;
    padding: 10px 0;
    box-sizing: border-box;
    .header-wrapper {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .title-wrapper {
        display: flex;
        align-items: center;
        height: 100%;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 18px;
        color: #191919;
      }
      .back-icon {
        position: absolute;
        left: 15px;
      }
      .close-btn {
        width: 66px;
        height: 20px;
        background: #f1f1f1;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        div {
          transform: translateY(-0.1em);
        }
      }
    }
    .drawer-content {
      padding-bottom: 10px;
      flex: 1;
      overflow-y: scroll;
    }
  }
</style>
